angular.module('unica_track.track_controllers')

.controller('TrackEditController', function(
	$rootScope, $scope, $state, $stateParams,
	TrackEditService
) {

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getTrack( $stateParams.id );

	$rootScope.trackData = {
		event_id: $stateParams.event_id,
	};

	$scope.saveTrack = function()
	{
		$scope.showLoader();

		var trackData = angular.copy($rootScope.trackData);

		TrackEditService
			.update( trackData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.showSuccessMsg('Track aggiornato con successo!', '');
				}
			});

	};

});